import React, {useEffect, useState} from 'react';
import Template from "../../layouts/Template";
import CurrentDevice from "../../components/CurrentDevice";
import {useAppSelector} from "../../states/hooks";
import LoadingOver from "../../components/LoadingOver";
import restApi from "../../api/restApi";
import helpers from "../../utils/helpers";
import smsDevice from "../../utils/smsDevice";
import './index.scss';
import Tooltip from "@mui/material/Tooltip";
import LockTwoToneIcon from "@mui/icons-material/LockTwoTone";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";
import PhoneInTalkTwoToneIcon from "@mui/icons-material/PhoneInTalkTwoTone";
import MicTwoToneIcon from "@mui/icons-material/MicTwoTone";
import MicOffTwoToneIcon from "@mui/icons-material/MicOffTwoTone";

//**********************************************************

function Index()
{
    const currentDeviceState = useAppSelector(state => state.deviceState);
    const userState = useAppSelector(state => state.userState);

    const [deviceData, setDeviceData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    //
    useEffect
    (
        () =>
        {
            if(currentDeviceState.deviceId !== '') getCurrentPosition();
        },
        [currentDeviceState]
    );

    // get current position
    const getCurrentPosition = () =>
    {
        setIsLoading(true);

        //
        restApi.get('/positions', {deviceId: currentDeviceState.deviceId}, userState).then
        (
            async function(response)
            {
                if(response != null && response.length > 0)
                {
                    setDeviceData(response[0]);
                }
                setIsLoading(false);
            }
        ).catch
        (
            function(error)
            {
            }
        ).finally
        (
            function()
            {
            }
        );
    };

    //--------------------
    return (
        <Template pageClass="page-last-status" pageTitle="گزارش وضعیت خودرو">
            <CurrentDevice/>

            {
                deviceData !== null ?
                    <div className="item-box">
                        <div className="item"><span className="title">نام خودرو</span><span className="value">{currentDeviceState.carName}</span></div>
                        <div className="item"><span className="title">شناسه imei</span><span className="value">{currentDeviceState.imei}</span></div>
                        <div className="item"><span className="title">سرعت</span><span className="value ltr">{helpers.initSpeed(deviceData.speed)} km</span></div>
                        <div className="item"><span className="title">مختصات خودرو</span><span className="value ltr">{helpers.initPosition(deviceData.latitude)} - {helpers.initPosition(deviceData.longitude)}</span></div>
                        <div className="item"><span className="title">تاریخ بروزرسانی gps</span><span className="value">{helpers.initDateOfDateTime(deviceData.fixTime)}</span></div>
                        <div className="item"><span className="title">ساعت بروزرسانی gps</span><span className="value">{helpers.initTimeOfDateTime(deviceData.fixTime)}</span></div>

                        {(deviceData.attributes.charge !== undefined) ? <div className="item"><span className="title">شارژ</span><span className="value">{deviceData.attributes.charge ? 'بله' : 'خیر'}</span></div> : null}
                        {/*{(deviceData.attributes.blocked !== undefined) ? <div className="item"><span className="title">بلوکه</span><span className="value">{deviceData.attributes.blocked ? 'بله' : 'خیر'}</span></div> : null}*/}
                        {(deviceData.attributes.batteryLevel !== undefined) ? <div className="item"><span className="title">باطری</span><span className="value">{deviceData.attributes.batteryLevel}%</span></div> : null}
                        {(deviceData.attributes.motion !== undefined) ? <div className="item"><span className="title">حرکت</span><span className="value">{deviceData.attributes.motion ? 'بله' : 'خیر'}</span></div> : null}
                        {(deviceData.attributes.ignition !== undefined) ? <div className="item"><span className="title">روشن</span><span className="value">{deviceData.attributes.ignition ? 'بله' : 'خیر'}</span></div> : null}
                        {(deviceData.attributes.door !== undefined) ? <div className="item"><span className="title">درب</span><span className="value">{deviceData.attributes.door ? 'باز' : 'بسته'}</span></div> : null}
                        {/*{(deviceData.attributes.fuel1 !== undefined) ? <div className="item"><span className="title">دما</span><span className="value">{deviceData.attributes.fuel1}</span></div> : null}*/}

                        {
                            currentDeviceState.deviceType === 'Coban' ? <>
                                <div className="item">
                                    <span className="title">{smsDevice.Coban.turnOff.title}</span>
                                    <span className="value">{currentDeviceState.cobanTurnOff === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Coban.alarmSpeed.title}</span>
                                    <span className="value">{helpers.isNumeric(currentDeviceState.cobanAlarmSpeed) ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Coban.alarmMoving.title}</span>
                                    <span className="value">{currentDeviceState.cobanAlarmMoving === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Coban.alarmTurnOn.title}</span>
                                    <span className="value">{currentDeviceState.cobanAlarmTurnOn === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Coban.activeSystem.title}</span>
                                    <span className="value">{currentDeviceState.cobanActiveSystem === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Coban.activeListen.title}</span>
                                    <span className="value">{currentDeviceState.cobanActiveListen === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>
                            </> : <>
                                <div className="item">
                                    <span className="title">{smsDevice.Concox.turnOff.title}</span>
                                    <span className="value">{currentDeviceState.concoxTurnOff === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmSpeed.title}</span>
                                    <span className="value">{helpers.isNumeric(currentDeviceState.concoxAlarmSpeed) ? (currentDeviceState.concoxAlarmSpeed + 'km') : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmDisconnectBattery.title}</span>
                                    <span className="value">{currentDeviceState.concoxAlarmDisconnectBattery === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmMoving.title}</span>
                                    <span className="value">{helpers.isNumeric(currentDeviceState.concoxAlarmMoving) ? (currentDeviceState.concoxAlarmMoving + 'm') : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmDoor.title}</span>
                                    <span className="value">{currentDeviceState.concoxAlarmDoor === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmImpact.title}</span>
                                    <span className="value">{currentDeviceState.concoxAlarmImpact === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmTurnOn.title}</span>
                                    <span className="value">{currentDeviceState.concoxAlarmTurnOn === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.alarmTurnOff.title}</span>
                                    <span className="value">{currentDeviceState.concoxAlarmTurnOff === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>

                                <div className="item">
                                    <span className="title">{smsDevice.Concox.activeSystem.title}</span>
                                    <span className="value">{currentDeviceState.concoxActiveSystem === 'on' ? 'فعال' : 'غیر فعال'}</span>
                                </div>
                            </>}
                    </div> : null}

            {/* loading */}
            {isLoading ? <LoadingOver /> : null}
        </Template>);
}

export default Index;
